import { createSlice } from '@reduxjs/toolkit';
import { getLegacyCiudades } from '../legacy/thunk.js';

export const initialState = {
    legacyCiudades: [],
    loading: false,
    error: {},
};

const legacyCiudadesSlice = createSlice({
    name: 'legacyCiudades',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyCiudades.fulfilled, (state, action) => {
            state.legacyCiudades = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyCiudades.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyCiudades.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyCiudadesSlice.reducer;